import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OrganizationsService } from "../../services/organizations.service";
import { Organization } from "../../models/organization";
import { Review } from "../../models/review";
import { ReviewsService } from "../../services/reviews.service";
import AppConstants from "../../constants/AppConstants";

@Component({
  selector: "app-reviews",
  templateUrl: "./reviews.component.html",
  styleUrls: ["./reviews.component.scss"],
})
export class ReviewsComponent {
  selectedOrganization: Organization;
  searchQuery = "";
  count: number;
  organizations: Organization[];
  reviews: Review[] = [];
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;
  constructor(
    private organizationService: OrganizationsService,
    private reviewsService: ReviewsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.paramMap.subscribe((params) => {
      const organizationId = params.get("organizationId");
      this.organizationService.list().subscribe((result) => {
        if (result && result.data) {
          this.organizations = result.data["organizations"].edges.map(
            (edge) => edge.node,
          );
          if (organizationId) {
            this.organizations.forEach((organization) => {
              if (organization.id === organizationId) {
                this.selectedOrganization = organization;
              }
            });
            this.fetchReviews(organizationId, this.DEFAULT_PAGINATION_INFO);
          }
        }
      });
    });
  }

  search(input) {
    this.pageIndex = 0;
    this.fetchReviews(
      this.selectedOrganization.id,
      this.DEFAULT_PAGINATION_INFO,
      input,
    );
  }

  fetchReviews(organizationId, pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        after: cursorForPage,
      },
      searchParam: searchParam,
    };

    this.reviewsService
      .getAllReviewsByOrganizationId(organizationId, obj)
      .subscribe((result) => {
        console.log(result);
        if (result && result.data) {
          this.reviews = result.data["reviews"].edges.map((edge) => edge.node);
          this.count = result.data["reviews"].totalCount;
          this.pageCursors[this.pageIndex] = result.data["reviews"].pageInfo;
        }
      });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchReviews(
      this.selectedOrganization.id,
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  selectOrganization() {
    if (this.selectedOrganization && this.selectedOrganization.id) {
      this.router.navigate(["/reviews/" + this.selectedOrganization.id]);
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/reviews/reviews.component.ts